import {
  Box,
  Divider,
  Drawer,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { useHelpDrawer } from "./HelpDrawerContext";
import { loadFAQ } from "./loadFAQ";
import FAQAccordion from "./FAQAccordion";
import ContactSupportForm from "./ContactSupportForm";

const DRAWER_WIDTH = 460;

const HelpDrawer = () => {
  const { open, product, scrollToSection, closeDrawer, clearScrollToSection } =
    useHelpDrawer();

  const payload = loadFAQ(product);
  const title = payload?.title ?? "Help";

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={closeDrawer}
      PaperProps={{
        "data-testid": "help-drawer",
        sx: {
          width: { xs: "100%", sm: DRAWER_WIDTH },
          maxWidth: "100vw",
        },
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: 2 }}
      >
        <Box>
          <Typography variant="overline" color="text.secondary">
            Help
          </Typography>
          <Typography variant="h6">{title}</Typography>
        </Box>
        <IconButton onClick={closeDrawer} aria-label="Close help">
          <CloseIcon />
        </IconButton>
      </Stack>
      <Divider />

      <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
        <FAQAccordion
          product={product}
          scrollToSection={scrollToSection}
          onScrollHandled={clearScrollToSection}
        />
      </Box>

      <Divider />
      <Box sx={{ p: 2 }}>
        <ContactSupportForm product={product} />
      </Box>
    </Drawer>
  );
};

export default HelpDrawer;
